var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32291 4.52271C4.40155 4.60422 4.53212 4.60422 4.61076 4.52271L8.60669 0.381398C8.72922 0.254411 8.63923 0.0425253 8.46277 0.0425253H0.470902C0.294439 0.0425253 0.204447 0.25441 0.326976 0.381398L4.32291 4.52271Z",
    fill: "#F97D09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDownArrow);
export default __webpack_public_path__ + "static/media/SelectedDownArrow.8130814c40c0acfca17ca78750e3ce93.svg";
export { ForwardRef as ReactComponent };